var x = Object.defineProperty, k = Object.defineProperties;
var g = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var a = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var r = (o, t, c) => t in o ? x(o, t, { enumerable: !0, configurable: !0, writable: !0, value: c }) : o[t] = c, h = (o, t) => {
  for (var c in t || (t = {}))
    a.call(t, c) && r(o, c, t[c]);
  if (s)
    for (var c of s(t))
      d.call(t, c) && r(o, c, t[c]);
  return o;
}, _ = (o, t) => k(o, g(t));
var l = (o, t) => {
  var c = {};
  for (var i in o)
    a.call(o, i) && t.indexOf(i) < 0 && (c[i] = o[i]);
  if (o != null && s)
    for (var i of s(o))
      t.indexOf(i) < 0 && d.call(o, i) && (c[i] = o[i]);
  return c;
};
import { a as j, j as B } from "../../../jsx-runtime-c20f6c15.mjs";
import f from "clsx";
import m from "../../../shared/icons/select.svg.mjs";
import "react";
const v = "_selectionHighlight_12fjr_1", H = "_radioButton_12fjr_8", b = "_checkBox_12fjr_11", C = "_container_12fjr_15", N = "_checked_12fjr_38", R = "_disabled_12fjr_49", n = {
  selectionHighlight: v,
  radioButton: H,
  checkBox: b,
  container: C,
  checked: N,
  disabled: R
};
var q = /* @__PURE__ */ ((o) => (o[o.CheckBox = 0] = "CheckBox", o[o.RadioButton = 1] = "RadioButton", o))(q || {});
function G(w) {
  var e = w, {
    disabled: o = !1,
    containerClassName: t,
    checked: c = !1,
    type: i = 0
  } = e, u = l(e, [
    "disabled",
    "containerClassName",
    "checked",
    "type"
  ]);
  return /* @__PURE__ */ j(
    "div",
    _(h({}, u), {
      className: f(
        n.container,
        {
          [n.checked]: c,
          [n.disabled]: o,
          [n.radioButton]: i === 1,
          [n.checkBox]: i === 0
        },
        t
      ),
      children: [
        /* @__PURE__ */ B(m, {}),
        /* @__PURE__ */ B(
          "div",
          {
            className: f({
              [n.selectionHighlight]: c,
              [n.radioButton]: i === 1,
              [n.checkBox]: i === 0
            })
          }
        )
      ]
    })
  );
}
export {
  q as SelectableType,
  G as default
};
